function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#DA1919"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M59.23 36.786c.503-2.18.77-4.452.77-6.786C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 1.253 0 2.488-.077 3.7-.226",
  transform: "translate(0 1) translate(1)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.415 0c.674 2.171.281 3.723-1.177 4.654-1.46.93-4.386 1.657-8.78 2.179",
  transform: "translate(0 1) translate(1) translate(8.057 1.657)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.38 3.416c-.254 2.1.038 3.993.876 5.682 2.128 4.29 6.94 10.546 6.518 12.716-.27 1.381-2.311.542-4.965 3.157-1.553 1.53 1.152 4.568-.829 6.121-.578.454-1.945.236-4.07 0-.668-.073-1.76.065-3.277.414M14.126 33.839c2.221-.273 3.718-.353 4.49-.24.998.147 1.952.216 2.189.853.48 1.29-.605 3.649-.588 4.885.015 1.148.671 2.412 0 3.325-.594.808-2.572 1.314-3.87 1.467-1.145.136-4.652.184-7.81-.976-1.74-.64-4.586-2.227-8.537-4.765M8.443 14.253c1.09.899 2.34 1.348 3.747 1.348s2.656-.45 3.746-1.348M8.265 43.226c-.61 2.228-.914 3.904-.914 5.028 0 1.125.305 2.801.914 5.029",
  transform: "translate(0 1) translate(1) translate(8.057 1.657)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1) translate(1) translate(30.914 30.914)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 1.871,
  rx: 0.5,
  transform: "rotate(-25 2.743 1.871)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 5.954,
  rx: 0.5,
  transform: "scale(1 -1) rotate(-25 -24.114 0)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.114,
  height: 1,
  x: 1.186,
  y: 3.913,
  rx: 0.5,
  transform: "matrix(1 0 0 -1 0 7.826)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.432 27.488c.66-.095 1.302-.246 1.922-.447 4.708-1.526 8.113-5.947 8.113-11.164 0-6.48-5.254-11.733-11.734-11.733-5.66 0-10.384 4.008-11.489 9.34",
  transform: "translate(0 1) translate(1) translate(31 32) translate(7.667)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 8.324c1.317.78 2.654 1.17 4.012 1.17 1.358 0 2.695-.39 4.012-1.17M9.756 0c.999.605 1.617 1.147 1.854 1.625.237.48.323 1.36.26 2.642",
  transform: "translate(0 1) translate(1) translate(31 32) translate(7.667)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 15.877c0 6.48 5.253 11.733 11.733 11.733s11.734-5.253 11.734-11.733h-8.571c-.49 1.82-1.543 2.731-3.163 2.731-1.619 0-2.668-.91-3.147-2.731H0z",
  transform: "translate(0 1) translate(1) translate(31 32)"
}))));

var SvgIconAllergyOralActive = function SvgIconAllergyOralActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAllergyOralActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-allergy_oral_active.ff5f44bc.svg";
export { ForwardRef as ReactComponent };